import React from "react";

const NotFoundPage = () => <div>Page Not Found</div>;

export default NotFoundPage;
